import { Account } from '@/domain/usecases'
import { LDClient } from 'launchdarkly-react-client-sdk'
import { QueryClient } from 'react-query'
import RegisteredPlanBaseLoader from '../registered-plan-base-loader'
import { upgradeRequestService } from '@/data/services/upgrade/upgrade-service'

export default class UpgradeRequestLoader extends RegisteredPlanBaseLoader {
  constructor(
    readonly account: Account.Model,
    readonly queryClient: QueryClient,
    readonly ldClient: LDClient | undefined
  ) {
    super(account, queryClient, ldClient)
  }

  async loader() {
    const [upgradeSettings, upgradeRequestStatus] = await Promise.all([
      upgradeRequestService.fetchSettings(this.account.company.uniqueId),
      upgradeRequestService.fetchPendingRequests(this.account.company.uniqueId)
    ])

    const response = {
      ...upgradeSettings,
      pendingResponse: upgradeRequestStatus
    }

    return this.defer({ data: response })
  }
}
